import type {
    UpsertUserInvestmentProfileBody,
    UserInvestmentProfile,
} from '@fruitful/investment-management';
import { useQueryClient } from '@tanstack/react-query';

import { requestBuilder } from '../../http/RequestBuilder';

const useUpsertUserInvestmentProfileAdminMutation = requestBuilder.mutation<
    UserInvestmentProfile,
    UpsertUserInvestmentProfileBody,
    { userId: string }
>({
    endpoint: (urlParams) =>
        `/api/admin/users/${urlParams.userId}/investment-profile`,
    method: 'POST',
});

export const useUpsertUserInvestmentProfileAdmin = () => {
    const queryClient = useQueryClient();

    return useUpsertUserInvestmentProfileAdminMutation({
        onSuccess: async (_data, { urlParams }) => {
            if (urlParams?.userId != null) {
                await queryClient.invalidateQueries({
                    queryKey: [
                        `admin/user/${urlParams.userId}/investment-profile`,
                    ],
                });
            }
        },
    });
};
